import { render, staticRenderFns } from "./cardTableReports.vue?vue&type=template&id=1321aeab&"
import script from "./cardTableReports.vue?vue&type=script&lang=js&"
export * from "./cardTableReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports